import { render, staticRenderFns } from "./needSomeHelp.vue?vue&type=template&id=2a891722&"
import script from "./needSomeHelp.vue?vue&type=script&lang=js&"
export * from "./needSomeHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports